import React, { useEffect, useState } from 'react';

export default function StepSuccess({ data, onDashboard }) {
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowDetails(true), 800);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="ob-card" style={{ textAlign: 'center', maxWidth: 500 }}>
      <div className="ob-success">
        <div className="ob-success-icon">🎉</div>
        <h1 className="ob-success-title">Almost live! One step left.</h1>
        <p className="ob-success-subtitle">
          <strong style={{ color: 'var(--text-primary)' }}>{data.businessName || 'Your business'}</strong> is set up on Aizaan.<br />
          Dial the forwarding code on your phone to activate call capture.
          Once done, every call will be captured, transcribed, and summarised automatically.
        </p>

        {showDetails && (
          <div style={{
            background: 'var(--bg-primary)',
            border: '1px solid var(--border)',
            borderRadius: 10,
            padding: 20,
            marginBottom: 24,
            textAlign: 'left',
            animation: 'fadeIn 0.4s ease',
          }}>
            <p style={{ fontSize: 12, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 14, fontWeight: 600 }}>
              Your setup summary
            </p>
            {[
              { label: 'Your dedicated number', value: data.virtualNumber || '+16592262669', mono: true },
              { label: 'Plan', value: data.plan?.charAt(0).toUpperCase() + data.plan?.slice(1) || 'Growth' },
              { label: 'Languages', value: (data.languages || ['English']).join(', ') },
              { label: 'Notifications', value: data.phone && (data.phone.startsWith('+1') || data.phone.startsWith('1')) ? 'SMS after every call' : 'WhatsApp after every call' },
              { label: 'Trial ends', value: (() => { const d = new Date(); d.setDate(d.getDate() + 14); return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }); })() },
            ].map(item => (
              <div key={item.label} style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px 0',
                borderBottom: '1px solid var(--border)',
                fontSize: 13,
              }}>
                <span style={{ color: 'var(--text-muted)' }}>{item.label}</span>
                <span style={{
                  color: 'var(--text-primary)',
                  fontWeight: 500,
                  fontFamily: item.mono ? 'var(--mono)' : 'inherit',
                  fontSize: item.mono ? 12 : 13,
                }}>
                  {item.value}
                </span>
              </div>
            ))}
          </div>
        )}

        <div style={{
          background: 'rgba(16,185,129,0.08)',
          border: '1px solid rgba(16,185,129,0.3)',
          borderRadius: 8,
          padding: '12px 16px',
          marginBottom: 24,
          fontSize: 13,
          color: 'var(--green)',
          lineHeight: 1.6,
        }}>
          {data.phone && (data.phone.startsWith('+1') || data.phone.startsWith('1')) ? '📱 We sent your setup details and forwarding code via SMS.' : '📱 We sent your setup details and forwarding code to your WhatsApp.'}{' '}You will receive a notification after your first call.
        </div>

        <button className="ob-btn ob-btn-primary" onClick={onDashboard} style={{ marginBottom: 12 }}>
          Go to my dashboard →
        </button>

        <p style={{ fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.6 }}>
          Call your Aizaan number <strong style={{ color: 'var(--text-primary)' }}>{data.virtualNumber}</strong> from any phone.<br />
          Within 60 seconds you will receive a call summary notification.
        </p>
      </div>
    </div>
  );
}
